import { render, staticRenderFns } from "./RosterConfirm.vue?vue&type=template&id=99377864&scoped=true&"
import script from "./RosterConfirm.vue?vue&type=script&lang=js&"
export * from "./RosterConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99377864",
  null
  
)

export default component.exports